import faker from 'faker'
import labels from 'src/../config/label.js'

export const mocker = {
  contacts (params) {
    let mockContacts = []
    const contactAmount = Math.floor((Math.random() * 100))
    const checkedAmount = Math.floor((contactAmount * Math.floor((Math.random() * 100))) / 100)
    for (var i = 0; i < contactAmount; i++) {
      mockContacts.push({
        checked: (i < checkedAmount),
        image_path: faker.image.avatar(),
        desc_codempid: faker.name.findName(),
        desc_codcomp: faker.lorem.sentence(),
        desc_codpos: faker.lorem.sentence(),
        numtelof: faker.phone.phoneNumberFormat(),
        numtelec: faker.phone.phoneNumberFormat(),
        email: faker.internet.email(),
        codempid: faker.lorem.word()
      })
    }
    return {
      total: contactAmount,
      rows: mockContacts
    }
  },
  fullnames () {
    let mockFullnames = []
    const fullnameAmount = Math.floor((Math.random() * 100))
    for (var i = 0; i < fullnameAmount; i++) {
      mockFullnames.push({
        codempid: faker.lorem.word(),
        p_desc_codempid: faker.name.findName()
      })
    }
    return {
      total: fullnameAmount,
      rows: mockFullnames
    }
  },
  companies () {
    let mockCompanies = []
    const companyAmount = Math.floor((Math.random() * 100))
    for (var i = 0; i < companyAmount; i++) {
      mockCompanies.push({
        codcomp: faker.lorem.word(),
        p_desc_codcomp: faker.lorem.sentence()
      })
    }
    return {
      total: companyAmount,
      rows: mockCompanies
    }
  },
  positions () {
    let mockPositions = []
    const positionAmount = Math.floor((Math.random() * 100))
    for (var i = 0; i < positionAmount; i++) {
      mockPositions.push({
        codpos: faker.lorem.word(),
        p_desc_codpos: faker.lorem.sentence()
      })
    }
    return {
      total: positionAmount,
      rows: mockPositions
    }
  },
  contactFavorite () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/contact/mocker.js